// Some constants that can be used to prevent eslint from moaning...

/** Type of property for ControlValueAccessor onModelChange()  */
export type OnChangeCallbackType = (_: any) => void;
/** Type of property for ControlValueAccessor onModelTouched()  */
export type OnTouchCallbackType = () => void;

/** Default function for onModelChange() callback */
export const DEFAULT_CHANGE_CALLBACK: OnChangeCallbackType = (_: any) => {
  return;
};
/** Default function for onModelTouched() callback */
export const DEFAULT_TOUCH_CALLBACK: OnTouchCallbackType = () => {
  return;
};
